import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paymentdone',
  templateUrl: './paymentdone.component.html',
  styleUrls: ['./paymentdone.component.css']
})
export class PaymentdoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
